import { create } from "zustand";
import { isFirstRecordingDone, markFirstRecordingDone } from "@/lib/onboarding";

interface PostOnboardingStoreState {
  done: boolean;
  markDone: () => void;
}

export const usePostOnboardingStore = create<PostOnboardingStoreState>()(
  (set) => ({
    done: isFirstRecordingDone(),
    markDone: (): void => {
      try {
        markFirstRecordingDone();
      } catch {
        // localStorage failures must never break a submit flow
      }
      set({ done: true });
    },
  })
);
